var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountBox2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16258 2.5C3.24385 2.5 2.5 3.24436 2.5 4.16258V15.8374C2.5 16.7562 3.24436 17.5 4.16258 17.5H15.8374C16.7562 17.5 17.5 16.7557 17.5 15.8374V4.16258C17.5 3.24385 16.7557 2.5 15.8374 2.5H4.16258ZM4.16667 15.8333V4.16667H15.8333V15.8333H4.16667ZM10 6.66667C10.4602 6.66667 10.8333 7.03977 10.8333 7.5C10.8333 7.96023 10.4602 8.33333 10 8.33333C9.53975 8.33333 9.16667 7.96023 9.16667 7.5C9.16667 7.03977 9.53975 6.66667 10 6.66667ZM10 10C11.3807 10 12.5 8.88075 12.5 7.5C12.5 6.11929 11.3807 5 10 5C8.61925 5 7.5 6.11929 7.5 7.5C7.5 8.88075 8.61925 10 10 10ZM10 12.5C9.0795 12.5 8.33333 13.2462 8.33333 14.1667H6.66667C6.66667 12.3257 8.15905 10.8333 10 10.8333C11.8409 10.8333 13.3333 12.3257 13.3333 14.1667H11.6667C11.6667 13.2462 10.9205 12.5 10 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBox2Line);
export default __webpack_public_path__ + "static/media/account-box-2-line.a21a30ad13a2884a688bb5d2b2b30778.svg";
export { ForwardRef as ReactComponent };